import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">GET YOUR STORY STRAIGHT</span>
                                            </div>

                                            <p>This exercise is designed to help you communicate your message
                                                effectively by sticking to the
                                                important points.</p>
                                            <div className="border_subtitle">Step 1</div>
                                            <p>Start by putting your communication into words. Your
                                                communication can be verbal or written and
                                                can take whatever form you like; for example a presentation, a
                                                letter or a chapter in a book.</p>
                                            <div className="border_subtitle">Step 2</div>
                                            <p>Next write a summary of your communication. This should be a
                                                written preview for the audience
                                                of no more than 30 words. As it’s a summary, use full sentences
                                                and proper English.</p>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport people_active">
                                                <tbody>
                                                <tr>
                                                    <th width="100%" align="left" valign="top"
                                                        className="green_curve green_curve1">Summary – 30 words
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="100%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="7"
                                                                  style={{width: '99%'}}
                                                                  name="summary"
                                                                  id="summary"
                                                                  value={this.props.pageData?.GetYourStoryStraight?.summary}
                                                                  onChange={this.props.handleChangePageData('GetYourStoryStraight')}/>

                                                        {this.props.pageData?.GetYourStoryStraight?.summary.split(' ').length >= 31 && <p className="color-red">
                                                            You've exceeded the 30 word limit
                                                        </p>}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <div className="border_subtitle">Step 3</div>
                                            <p>Once you have finished, review your original communication in
                                                light of your summary and delete
                                                any points from the original that are not in your summary.</p>
                                            <p>This will enable you to think about the story behind your
                                                communication, while sticking only to the
                                                key points to get your message across. It’ll make you focus and
                                                minimise repetition and digression.
                                                Don’t worry if it takes you a bit of time at first, your
                                                communication will be more effective as
                                                a result…</p>
                                            <div className="border_subtitle">In the words of George Bernard
                                                Shaw…
                                            </div>
                                            <div
                                                className="lightgreencontentbg keyquestionpad greennumberroundbg1 lightbgcontentShrink uiheading">
                                                <p>‘I’m sorry to have written such a long letter, but I didn’t
                                                    have time to write a shorter one.’</p></div>
                                            <br/>
                                                <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                    <span className="heading">DO YOU AGREE WITH YOU?</span>
                                                </div>

                                                <p>This will help you develop your oral communication skills
                                                    like presentations or speeches. It’s easy
                                                    to just read through the information we’ve given you and
                                                    then think you’re applying it. However,
                                                    that rarely happens.</p>
                                                <p>So, in this exercise you’ll record your behaviour to see how
                                                    you really do communicate. It will
                                                    make you more aware of your style so you can make
                                                    adjustments where appropriate, because
                                                    many of us do things like using fillers without realising
                                                    it. You can choose how to do the first step:</p>
                                                <div className="border_subtitle">Step 1 – Video yourself</div>
                                                <div className="paraspace"><p>This would be ideal (using a
                                                    camera, camcorder or mobile phone) to give you as much
                                                    information
                                                    as possible about how your presentation or speech sounds and
                                                    looks. Once you’ve done it:</p></div>
                                                <ul className="greenbullet-list" style={{margin:'0px'}}>
                                                    <li>Play the video back and rate your performance in each of
                                                        the ‘behaviours’ in the table on
                                                        the next page, using a scale of 1-4.
                                                    </li>
                                                    <li>Pretend you’re someone in an audience, listening to you
                                                        – would you be convinced?
                                                    </li>
                                                </ul>


                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page4')}
                                                        className="button-next-previous-done">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div
                                                        onClick={this.props.savePageData('Page6')}
                                                        className="button-next-previous-done">Next &gt;&gt;</div>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }